import { ProductConfigurationResponse } from '../../../api/ConfigApi';
import {
	Exposure,
	ExposureCreateRequest,
	FieldValuesMap,
	PerilCreateRequest,
} from '../../../types/policy';
import { removeLimitsFromPerilConfig } from '../../../util/util';
import { DefaultValuesType, FormBuilder } from '../types';
import { getPerilFields } from '../utils';
import getDefaultPerilValues from './getDefaultPerilValues';

const getEndorsementRenewalExposureAddedPerilForm = (
	selectedPeril: PerilCreateRequest,
	selectedExposure: ExposureCreateRequest | Exposure,
	currency: string,
	productConfig: ProductConfigurationResponse,
	hidePerilLimitsEnabled: boolean,
) => {
	const exposureName =
		(selectedExposure as Exposure).name ||
		(selectedExposure as ExposureCreateRequest).exposureName;

	const policyConfig = productConfig.policyConfiguration;
	const exposureConfig = policyConfig.exposures.find(
		(exposure) => exposure.name === exposureName,
	);
	let perilConfig = exposureConfig.perils.find(
		(p) => p.name === selectedPeril.name,
	);
	// Remove limit fields from peril config if FF is enabled
	if (hidePerilLimitsEnabled) {
		perilConfig = removeLimitsFromPerilConfig(perilConfig);
	}

	const fields = [...perilConfig.fields];
	const perilFieldValues = selectedPeril.fieldValues;
	const fieldValues = perilFieldValues;
	const fieldGroups = selectedPeril.fieldGroups;

	let values: FieldValuesMap = {
		...fieldValues,
	};
	// If limits are shown, get default values and append limits fields before fieldValues
	if (!hidePerilLimitsEnabled) {
		const indemnityValues = getDefaultPerilValues(selectedPeril);

		const fieldGroupValues = {} as DefaultValuesType;

		fieldGroups.forEach((fieldGroup) => {
			fieldGroupValues[fieldGroup.fieldName] = [];
		});

		values = {
			...indemnityValues,
			...values,
			...fieldGroupValues,
		} as FieldValuesMap;

		if (fields.length > 0) {
			fields[0].newline = true;
		}

		fields.unshift(...getPerilFields(currency));
	}

	const perilForm = {
		fields,
		fieldGroupsByLocator: {},
		values,
		fieldGroups,
		mediaByLocator: {},
	} as FormBuilder;

	return perilForm;
};

export default getEndorsementRenewalExposureAddedPerilForm;
